import type { Product } from "@/types";
import { itemMatchesPromotion, type Promotion } from "@/lib/promotions";

/**
 * Een product staat "in de sale" als het is afgeprijsd óf onder een lopende actie valt (Ten Cate 2+1,
 * nachtmode -10%, ...). Dezelfde regel als de weergave /shop?sale=1 (besluit NB8, aanbevolen optie: acties
 * tellen mee). Wie alleen doorgehaalde prijzen wil, laat het tweede deel hier weg.
 */
export function productIsOnSale(p: Product, promotions: ReadonlyArray<Promotion>): boolean {
  if (p.salePrice && p.salePrice < p.price) return true;
  const item = { brand: p.brand, slug: p.slug, productId: p.id, price: p.price, quantity: 1 };
  return promotions.some((promo) => itemMatchesPromotion(item, promo));
}
